import { FormGroup } from '@angular/forms';
import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';

import { NomOutputFormat } from 'src/app/core/constants';
import { OutputSettings } from 'src/app/core/models/output-settings.models';

import { Observable } from 'rxjs';

interface FormatTab {
  key: NomOutputFormat;
  label: string;
  icon: any;
}

@Component({
  selector: 'app-feed-level-layout-and-format',
  templateUrl: './feed-level-layout-and-format.component.html',
  styleUrl: './feed-level-layout-and-format.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FeedLevelLayoutAndFormatComponent implements OnInit {
  @Input() outputSettings: OutputSettings;
  @Input() formatFormGroups: Map<NomOutputFormat, FormGroup>;
  @Input() searchString$: Observable<string>;

  public activeFormatTab: NomOutputFormat = NomOutputFormat.DOCX;
  public visibleTabs: FormatTab[] = [];

  constructor() {}

  ngOnInit(): void {
    this.initializeTabs();
  }

  private initializeTabs(): void {
    const allTabs: FormatTab[] = [
      {
        key: NomOutputFormat.DOCX,
        label: 'output-settings.tab.msword',
        icon: ['fas', 'file-word'],
      },
      {
        key: NomOutputFormat.CSV,
        label: 'output-settings.tab.csv',
        icon: ['fas', 'file-csv'],
      },
      {
        key: NomOutputFormat.HTML,
        label: 'output-settings.tab.html',
        icon: ['fas', 'file-code'],
      },
    ];

    this.visibleTabs = allTabs.filter(
      (tab) => this.formatFormGroups && this.formatFormGroups.has(tab.key),
    );

    if (this.visibleTabs.length > 0) {
      this.activeFormatTab = this.visibleTabs[0].key;
    }
  }

  changeFormatTab(formatKey: NomOutputFormat): void {
    this.activeFormatTab = formatKey;
  }

  getFormGroupForFormat(formatKey: NomOutputFormat): FormGroup | undefined {
    return this.formatFormGroups?.get(formatKey);
  }
}
